import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// Lazy load components
const SupplierList = lazy(() => import('../Pages/SupplierList'));
const AddSupplier = lazy(() => import('../Pages/AddSupplier'));
const EditSupplier = lazy(() => import('../Pages/EditSupplier'));
const SupplierView = lazy(() => import('../Pages/SupplierView'));
const AddSupplierV2 = lazy(() => import('../Pages/AddSupplierV2'));
const EditSupplierV2 = lazy(() => import('../Pages/EditSupplierV2'));
const SupplierViewV2 = lazy(() => import('../Pages/SupplierViewV2'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/supplier.scss';

function SupplierRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/supplier"
        render={() => (
          <Suspense fallback={<Loading />}>
            <SupplierList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/list"
        render={() => (
          <Suspense fallback={<Loading />}>
            <SupplierList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/add"
        render={() => (
          <Suspense fallback={<Loading />}>
            <AddSupplierV2 history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/edit/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <EditSupplierV2 history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/view/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <SupplierViewV2 history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/add-v2"
        render={() => (
          <Suspense fallback={<Loading />}>
            <AddSupplierV2 history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/edit-v2/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <EditSupplierV2 history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/view-v2/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <SupplierViewV2 history={history} />
          </Suspense>
        )}
      />
    </Switch>
  );
};

export default SupplierRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
